import ProviderDataConsumer from "./ProviderDataConsumer";
import ProviderDataConsumerTransetionDetails from "./ProviderDataConsumerTransetionDetails";
import ConsumerPurchasedDataUnits from "./ConsumerPurchasedDataUnits";
const DataConsumersProviderMain={
     ProviderDataConsumer,
     ProviderDataConsumerTransetionDetails,
     ConsumerPurchasedDataUnits
}
export default DataConsumersProviderMain
